// Test IDs for the auth feature (login, register, password reset, logout).
// Add new keys here as you wire up additional auth UI; see ./index.js for
// the recipe to add a new feature file.
//
// Directive:
//   - Keys are camelCase, values are kebab-case shaped as `<feature>-<element>`
//     (or `<feature>-<element>-<qualifier>` when an element repeats). Examples:
//     'login-submit-button', 'cart-quantity-input', 'product-card-image'.
//   - Reference them in JSX as `data-testid={LOGIN.submitButton}`.
//
// Why kebab-case values: required by qabot's CSS-attribute selector matcher
// and the lint rule `emergent(kebab-case-testid)`.

export const LOGIN = {
	emailInput: 'login-email-input',
	passwordInput: 'login-password-input',
	submitButton: 'login-submit-button',
	forgotPasswordLink: 'login-forgot-password-link',
	registerLink: 'login-register-link',
};

export const REGISTER = {
	nameInput: 'register-name-input',
	emailInput: 'register-email-input',
	passwordInput: 'register-password-input',
	passwordConfirmInput: 'register-password-confirm-input',
	submitButton: 'register-submit-button',
	loginLink: 'register-login-link',
};

export const LOGOUT = {
	button: 'logout-button',
};

// Shared client auth UI (Google + email OTP) — components/auth/ClientAuthPanel.jsx
// and ClientAuthDialog.jsx, gating every public transactional action. See
// docs/auth-and-admin/client-otp-auth-contract.md for the full contract.
export const CLIENT_AUTH = {
	dialog: 'client-auth-dialog',
	// The panel root — the self-contained light card (BUG-047). Named so the
	// palette it must declare for itself is assertable, in Jest and in the
	// browser-QA contrast check (scripts/browser_qa/s12_public_bugsheet.py).
	panel: 'client-auth-panel',
	emailInput: 'client-auth-email-input',
	sendCodeButton: 'client-auth-send-code-button',
	emailError: 'client-auth-email-error',
	otpInput: 'client-auth-otp-input',
	verifyButton: 'client-auth-verify-button',
	resendButton: 'client-auth-resend-button',
	// "Use a different email" on the code step — the way back to the email form
	// (BUG-044). Registered here like every sibling: a literal in the JSX plus a
	// literal in the test is two places to drift, which is what this file exists to
	// prevent.
	changeEmailButton: 'client-auth-change-email-button',
	googleButton: 'client-auth-google-button',
	error: 'client-auth-error',
	// The unticked "Send me news and offers from {practice} by email" box (practice hosts only).
	marketingConsent: 'client-auth-marketing-consent',
	// The REQUIRED terms of use + privacy policy box, its refusal and its two links.
	termsAccept: 'client-auth-terms-accept',
	termsError: 'client-auth-terms-error',
	termsLink: 'client-auth-terms-link',
	privacyLink: 'client-auth-privacy-link',
};
